import { useEffect } from "react";
import api from "../lib/api";

// Injects admin-provided custom head code (meta tags, scripts) into <head>.
export const HeadCodeInjector = () => {
  useEffect(() => {
    let injected = [];
    api.get("/public/home-settings").then(r => {
      const code = r.data?.custom_head_code;
      if (!code || !code.trim()) return;
      const tpl = document.createElement("template");
      tpl.innerHTML = code;
      Array.from(tpl.content.childNodes).forEach(node => {
        if (node.nodeType !== 1) return; // elements only
        let el;
        if (node.tagName === "SCRIPT") {
          // scripts must be recreated to execute
          el = document.createElement("script");
          Array.from(node.attributes).forEach(a => el.setAttribute(a.name, a.value));
          el.textContent = node.textContent;
        } else {
          el = node.cloneNode(true);
        }
        el.setAttribute("data-custom-head", "true");
        document.head.appendChild(el);
        injected.push(el);
      });
    }).catch(() => {});
    return () => injected.forEach(el => el.remove());
  }, []);
  return null;
};
